import { render, staticRenderFns } from "./foc_deliver.vue?vue&type=template&id=a2cbfef2&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "foc_deliver.vue"
export default component.exports